module.exports = __webpack_public_path__ + "img/piccolos.940c3351.svg";